/* eslint-disable no-undef, react/prop-types */
import React from 'react';

import PageWrapper from '../components/PageWrapper';
import Helmet from "react-helmet";
import ButtonPrimary from '../components/Buttons';

const Shop = () => (
  <PageWrapper>
    <Helmet>
      <title>通信販売部 | ちぇるのやるすく工廠</title>
      <meta name="description" content="作品を販売しております" />
      <html lang="ja" />
    </Helmet>
    <div>
      <h1>通信販売部</h1>
      <h4>
        頒布を行っている同人作品については、以下サービスにて通信販売を行っております。
      </h4>
      <h2>BOOTH</h2>
      <p>
        ※発送の過程で取得した個人情報は発送及び各種トラブル対処にのみ使用し、個人としては記録を行いません。
      </p>
      <div style={{ textAlign: 'center' }} >
        <a rel="noopener" target="_blank" href="https://htkn.booth.pm/">
          <ButtonPrimary>BOOTHを見る</ButtonPrimary>
        </a>
      </div>
      <h2>とらのあな</h2>
      <div style={{ textAlign: 'center' }} >
        <a rel="noopener" target="_blank" href="https://ecs.toranoana.jp/tora/ec/cot/circle/2UPA1E6Q8875d46Pd687/all/">
          <ButtonPrimary>とらのあなを見る</ButtonPrimary>
        </a>
      </div>
      <h2>DLsite</h2>
      <p>
        過去作については、DLsite側の割引キャンペーンによってお手頃な価格となります。
      </p>
      <div style={{ textAlign: 'center' }} >
        <a rel="noopener" href="https://www.dlsite.com/home/circle/profile/=/maker_id/RG46683.html/?utm_medium=affiliate&utm_campaign=bnlink&utm_content=bn_pc_468_60_dojin_01.jpg" target="_blank">
          <ButtonPrimary>DLsiteを見る</ButtonPrimary>
        </a>
      </div>
    </div>
  </PageWrapper>
);

export default Shop;
